import React from "react";

const ComingSoon = ({ icon: Icon, title, description }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "60vh",
      textAlign: "center",
      padding: "2rem",
    }}
  >
    <div className="w-16 h-16 rounded-2xl bg-gray-100 flex items-center justify-center mb-6">
      <Icon className="w-8 h-8 text-gray-400" />
    </div>
    <h2 className="text-base font-medium text-gray-800 mb-2">{title}</h2>
    <p className="text-sm text-gray-500 max-w-xs leading-relaxed">{description}</p>
    <span className="mt-4 inline-block text-xs text-gray-400 border border-gray-200 rounded-full px-3 py-1">
      Sắp ra mắt
    </span>
  </div>
);

export default ComingSoon;